<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Data Pegawai</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagpegawai">Data Pegawai</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Data Pegawai</h4>
                  <p class="card-title-desc mb-0">Data Pejabat / Pegawai.</p>
                </div>
                <div>
                  <Link class="btn btn-success" href="/admin/indagpegawai/tambah">Tambah Baru</Link>
                </div>
              </div>

              <hr>

              <data-attribut :data="indagpegawai">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">No</th>
                      <th>Pegawai</th>
                      <th class="text-center">Golongan / Pangkat</th>
                      <th>Jabatan</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in indagpegawai.data" :key="index">
                      <td scope="row" class="text-center">{{ indagpegawai.from + index }}</td>
                      <td scope="row">
                        <p class="m-0 fw-bold" v-text="row.nama_lengkap"></p>
                        <span>NIP: {{ row.nip || '-' }}</span>
                      </td>
                      <td scope="row" class="text-center">
                        <span v-text="pangkat(row.pangkat_golongan)"></span>
                        <p class="mp-0" v-text="row.pangkat_golongan.replace(pangkat(row.pangkat_golongan), '')"></p>
                      </td>
                      <td scope="row" v-text="row.jabatan"></td>
                      <td scope="row" class="text-center">
                        <Link :href="`/admin/indagpegawai/${row.id}`" class="p-0 btn btn-sm btn-link">Edit</Link> | 
                        <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                      </td>
                    </tr>
                    <tr v-if="indagpegawai.data.length == 0">
                      <td scope="row" colspan="6" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagpegawai: Object
  },
  methods: {
    pangkat(pg) {
      return pg.substring(0, pg.length - pg.split('').reverse().indexOf(' '));
    },
    remove(row) {
      if(confirm('Yakin hapus data?'))
      this.$inertia.delete('/admin/indagpegawai/' + row.id);
    }
  },
}
</script>
